
<main>
    <div class="city-search">
        <div class="filtering">
            <form>
                <input type="search" class="form-control" #filter (keyup)="applyFilter($event)" placeholder="શોધો.." />
                <i class="ti ti-search"></i>
            </form>
            <i class="ti ti-filter cursorClass" (click)="openBottomSheet()"></i>
            <a class="ti ti-refresh cursorClass" (click)="getMainMember()"></a>

        </div>
    </div>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <mat-tab-group mat-stretch-tabs="true" mat-align-tabs="center">
                    <mat-tab label="કાર્યક્રમ દાતાઓ સભ્યો">
                        <div *ngIf="memberFilterData.length !== 0" class="main-members family-tabs">
                            <a class="member-list-item">
                                <div>
                                    <h5><b>બધા કાર્યક્રમ દાતાઓ પસંદ કરો.</b></h5>
                                </div>
                                <mat-checkbox #selectAllCheckbox1 class="example-margin"
                                    (change)="selectAllMembers($event)"></mat-checkbox>
                            </a>
                        </div>

                        <div class="main-members family-tabs">
                            <a *ngFor="let member of memberFilterData" class="member-list-item">
                                <div>
                                    <h5>{{ member.name}}</h5>
                                </div>
                                <mat-checkbox class="example-margin" [(ngModel)]="member.checked"
                                    (change)="invitationFunction($event, member.user_id)"></mat-checkbox>
                            </a>
                        </div>
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
    </div>
    <button type="submit" class="btn-common stickeybtn" (click)="submit()">સાચવો</button>
</main>